var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7762 1.18468C16.6861 1.09502 16.5723 1.03295 16.4482 1.00575C16.324 0.97856 16.1947 0.987376 16.0754 1.03117L1.39167 6.37069C1.26504 6.41873 1.15601 6.50415 1.07908 6.61561C1.00214 6.72708 0.960938 6.85931 0.960938 6.99475C0.960938 7.13019 1.00214 7.26242 1.07908 7.37389C1.15601 7.48535 1.26504 7.57078 1.39167 7.61881L7.79911 10.1818L10.3621 16.5892C10.4102 16.7103 10.4928 16.8146 10.5995 16.8893C10.7063 16.9641 10.8325 17.0059 10.9628 17.0097C11.0977 17.0069 11.2285 16.9634 11.3382 16.8847C11.4478 16.8061 11.531 16.6961 11.5768 16.5692L16.9164 1.88549C16.9618 1.7674 16.9728 1.63882 16.948 1.51474C16.9232 1.39066 16.8636 1.27619 16.7762 1.18468ZM10.9628 14.4734L9.10062 9.80134L12.2977 6.6043L11.3566 5.66321L8.13283 8.88695L3.48744 6.99809L15.1877 2.77319L10.9628 14.4734Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1bb76cdc.svg";
export { ForwardRef as ReactComponent };